<template>
  <div class="materialsDetail">
    <div class="main">
      <el-form ref="baseForm" class="baseForm" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="选择证书和等级：" prop="jobList">
          <el-cascader
            v-model="form.jobList"
            placeholder="请选择证书/等级"
            :options="jobLevelList"
            :props="{
              value: 'id',
              label: 'jobName',
              children: 'levelList',
            }"
            :disabled="isReadonly"
            @change="handleJobLevelChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input v-model="form.phone" placeholder="手机号" :disabled="isReadonly"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名：" prop="name">
          <el-input v-model="form.name" placeholder="姓名" :disabled="isReadonly"></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="idCard">
          <el-input
            v-model="form.idCard"
            placeholder="身份证号"
            :maxlength="32"
            :disabled="isReadonly"
          ></el-input>
        </el-form-item>
        <el-form-item label="证件照片：" prop="photoFront">
          <div class="imageUpload">
            <div class="imageFront">
              <el-upload
                ref="upload"
                action="/api/third/api/tencentUpload/upload/file/local"
                accept=".jpg,.jpeg,.png,.gif,.svg,.JPG,.JPEG"
                :show-file-list="false"
                :multiple="true"
                :on-success="handlePhotoFrontSuccess"
                :before-upload="beforeAvatarUpload"
                :disabled="isReadonly"
              >
                <img v-if="form.photoFront" :src="form.photoFront" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">正面</div>
              </el-upload>
            </div>
            <div class="imageBack">
              <el-upload
                ref="upload"
                action="/api/third/api/tencentUpload/upload/file/local"
                accept=".jpg,.jpeg,.png,.gif,.svg,.JPG,.JPEG"
                :show-file-list="false"
                :multiple="true"
                :on-success="handlePhotoBackSuccess"
                :before-upload="beforeAvatarUpload"
                :disabled="isReadonly"
              >
                <img v-if="form.photoBack" :src="form.photoBack" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">背面</div>
              </el-upload>
            </div>
          </div>
          <div class="tip">大小20MB，支持jpg、png、jpeg</div>
        </el-form-item>
        <el-form-item label="登记照：" prop="registrationPhoto">
          <div class="registrationPhoto">
            <el-upload
              ref="upload"
              action="/api/third/api/tencentUpload/upload/file/local"
              accept=".jpg,.jpeg,.png,.gif,.svg,.JPG,.JPEG"
              :show-file-list="false"
              :multiple="true"
              :on-success="handleRegistrationPhotoSuccess"
              :before-upload="beforeAvatarUpload1"
              :disabled="isReadonly"
            >
              <img v-if="form.registrationPhoto" :src="form.registrationPhoto" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">
                1寸（295×413）彩色免冠照片，大小10MB内，支持.png，最多可上传1张
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="最高学历：" prop="highestDegree">
          <el-select v-model="form.highestDegree" clearable :disabled="isReadonly">
            <el-option label="硕士" value="硕士"></el-option>
            <el-option label="本科" value="本科"></el-option>
            <el-option label="专科" value="专科"></el-option>
            <el-option label="高中" value="高中"></el-option>
            <el-option label="初中及以下" value="初中及以下"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.highestDegree" label="毕业证书照片：" prop="diplomaPhoto">
          <div class="registrationPhoto">
            <el-upload
              ref="upload"
              action="/api/third/api/tencentUpload/upload/file/local"
              accept=".jpg,.jpeg,.png,.gif,.svg,.JPG,.JPEG"
              :show-file-list="false"
              :multiple="true"
              :on-success="handleDiplomaPhotoSuccess"
              :before-upload="beforeAvatarUpload2"
              :disabled="isReadonly"
            >
              <img v-if="form.diplomaPhoto" :src="form.diplomaPhoto" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">
                大小5MB，支持.png.jpg.jpeg，最多可上传1张
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item v-if="form.highestDegree" label="毕业证书编号：" prop="diplomaNumber">
          <el-input
            v-model="form.diplomaNumber"
            placeholder="请输入毕业证上的编号"
            :disabled="isReadonly"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="form.highestDegree" label="毕业专业：" prop="major">
          <el-autocomplete
            v-model="form.major"
            :fetch-suggestions="querySearch"
            placeholder="请输入毕业证上描述的专业"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="所在单位：" prop="company">
          <el-input
            v-model="form.company"
            placeholder="请输入目前所在单位名称"
            :disabled="isReadonly"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="form.highestDegree" label="工作证明：" prop="workCertificateList">
          <div class="workUpload">
            <el-upload
              action="/api/third/api/tencentUpload/upload/file/local"
              accept=".docx,.doc,.pdf,.jpg,.png"
              :limit="1"
              :on-preview="handleDownLoad"
              :on-remove="handleWorkCertificateRemove"
              :on-success="handleBeforeWorkCertificateFileUpload"
              :file-list="form.workCertificateList"
              :disabled="isReadonly"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <template v-slot:tip>
                <div class="explain">
                  证明需要是所在单位开具，文件限制10MB内，支持.png.pdf.jpg.jpeg等。
                </div>
              </template>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="参保证明：" prop="proofList">
          <div class="workUpload">
            <el-upload
              action="/api/third/api/tencentUpload/upload/file/local"
              accept=".docx,.doc,.pdf,.jpg,.png"
              :limit="1"
              :on-preview="handleDownLoad"
              :on-remove="handleProofListRemove"
              :on-success="handleProofListFileUpload"
              :file-list="form.proofList"
              :disabled="isReadonly"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <template v-slot:tip>
                <div class="explain">
                  文件大小限制10MB，支持.docx.doc，最多可上传1个
                </div>
              </template>
            </el-upload>
            <div class="downLoadCard">
              <span class="download-text" @click="downloadTemp('湖北（支付宝）参保证明下载流程')"
                >湖北(支付宝)参保证明下载流程说明.pdf</span
              >
              <span class="download-text" @click="downloadTemp('湖北（政务服务网）参保下载流程')"
                >湖北(政务服务网)参保下载流程.pdf</span
              >
              <span
                class="download-text"
                @click="downloadTemp('湖北（支付宝）参保证明下载流程（无电子社保卡版）')"
                >湖北（支付宝）参保证明下载流程（无电子社保卡版）.pdf</span
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="附件：" prop="attachmentList">
          <div class="workUpload">
            <el-upload
              action="/api/third/api/tencentUpload/upload/file/local"
              accept=".docx,.doc,.pdf"
              :limit="10"
              :on-preview="handleDownLoad"
              :on-remove="handleAttachmentListRemove"
              :on-success="handleAttachmentListFileUpload"
              :file-list="form.attachmentList"
              :disabled="isReadonly"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <template v-slot:tip>
                <div class="explain">
                  文件大小限制10MB，支持.docx.doc，最多可上传10个
                </div>
              </template>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="checkBtn"
            :disabled="isReadonly"
            @click="handleCheckMaterial"
            >审核</el-button
          >
        </el-form-item>
      </el-form>
      <div class="btnGroup">
        <div class="btnCard">
          <el-button
            type="primary"
            class="checkBtn"
            :disabled="!form.prefixId"
            @click="handleGetPreFn"
            >上一个</el-button
          >
          <el-button
            type="primary"
            class="checkBtn"
            :disabled="!form.nextId"
            @click="handleGetNextFn"
            >下一个</el-button
          >
          <el-button type="primary" class="checkBtn" @click="handleGoBack">返回</el-button>
        </div>
      </div>
    </div>
    <SingleCheck ref="SingleCheck" @success="handleBackPath"></SingleCheck>
  </div>
</template>
<script>
import to from 'await-to'
import SingleCheck from './components/singleCheck'
import { materialsInfoQuery, materialsInfoEdit, certificateMajor, workJudge } from '@/api/apply'
import { filterJobLevel } from '@/api/exam'
export default {
  components: {
    SingleCheck,
  },
  data() {
    var checkIdCard = (rule, value, callback) => {
      const reg = /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/
      if (reg.test(value) === false) {
        callback(new Error('请输入正确的身份证号码'))
      } else {
        callback()
      }
    }
    return {
      id: this.$route.query.id || '',
      isReadonly: false,
      form: {
        jobList: [],
        phone: '',
        name: '',
        idCard: '',
        photoList: [],
        photoFront: '',
        photoBack: '',
        registrationPhoto: '',
        highestDegree: '',
        diplomaPhoto: '',
        diplomaNumber: '',
        major: '',
        company: '',
        workCertificateList: [],
        proofList: [],
        attachmentList: [],
      },
      rules: {
        jobList: [{ required: true, message: '请选择证书/等级', trigger: 'change' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: checkIdCard, trigger: 'blur' },
        ],
        photoFront: [{ required: true, message: '请上传证件照片', trigger: 'blur' }],
        photoBack: [{ required: true, message: '请上传证件照片', trigger: 'blur' }],
        registrationPhoto: [{ required: true, message: '请上传登记照片', trigger: 'blur' }],
        highestDegree: [{ required: true, message: '请选择最高学历', trigger: 'change' }],
        // diplomaPhoto: [{ required: true, message: '请上传毕业证书照片', trigger: 'blur' }],
        // diplomaNumber: [{ required: true, message: '请输入毕业证书编号', trigger: 'blur' }],
        // major: [{ required: true, message: '请输入毕业专业', trigger: 'blur' }],
        company: [{ required: true, message: '请输入所在单位', trigger: 'blur' }],
        // workCertificateList: {
        //   required: true,
        //   type: 'array',
        //   message: '请上传工作证明',
        //   validator: (rule, value, callback) => {
        //     value = this.form.workCertificateList
        //     if (!value || value.length == 0) {
        //       return callback(new Error('请上传工作证明'))
        //     } else {
        //       return callback()
        //     }
        //   },
        // },
      },
      jobLevelList: [],
      majorList: [],
    }
  },
  mounted() {
    if (this.id) {
      this.handleMaterialsQueryFn(this.id)
      this.getJobLevelList()
      if (this.$route.query.readonly) this.isReadonly = true
    }
  },
  methods: {
    querySearch(queryString, cb) {
      var majorList = this.majorList
      var results = queryString ? majorList.filter(this.createFilter(queryString)) : majorList
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return majorList => {
        return majorList.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    downloadTemp(name) {
      const href = `/${name}.pdf`
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = href
      a.download = name
      a.click()
      URL.revokeObjectURL(a.href)
    },
    handleGoBack() {
      this.$router.push({ path: '/apply/checkMaterials' })
    },
    handleGetPreFn() {
      if (this.form.prefixId) {
        this.handleMaterialsQueryFn(this.form.prefixId)
      }
    },
    handleGetNextFn() {
      if (this.form.nextId) {
        this.handleMaterialsQueryFn(this.form.nextId)
      }
    },
    handleBackPath() {
      this.$router.push({ path: `/apply/checkMaterials` })
    },
    handleCheckMaterial() {
      this.$refs['baseForm'].validate(async valid => {
        if (!valid) return
        if (this.form.highestDegree == '高中' || this.form.highestDegree == '初中及以下') {
          if (this.form.workCertificateList.length == 0)
            return this.$message.warning('请上传工作证明！')
          this.SubMitFn()
        } else {
          if (!this.form.diplomaPhoto) return this.$message.warning('请上传毕业证书照片')
          if (!this.form.diplomaNumber) return this.$message.warning('请输入毕业证书编号')
          if (!this.form.major) return this.$message.warning('请输入毕业专业')
          const [res, err] = await to(workJudge({ jobId: this.form.jobId, major: this.form.major }))
          if (err) return this.$message.warning(err.msg)
          if (res.data && this.form.workCertificateList.length == 0)
            return this.$message.warning('请输入工作证明')
          this.SubMitFn()
        }
      })
    },
    async SubMitFn() {
      const [, err] = await to(materialsInfoEdit({ ...this.form }))
      if (err) return this.$message.warning(err.msg)
      this.$refs.SingleCheck.show(this.form.id)
    },
    async getJobLevelList() {
      const [res, err] = await to(filterJobLevel({}))
      if (err) return this.$message.warning(err.msg)
      this.jobLevelList = res.data
    },
    handleJobLevelChange() {
      if (this.form.jobList.length > 0) {
        this.form.jobId = this.form.jobList[0]
        this.form.jobLevel = this.form.jobList[1]
        this.handleGetMajorList(this.form.jobId)
      }
    },
    async handleGetMajorList(id) {
      const [res, err] = await to(certificateMajor({ jobId: id }))
      if (err) return this.$message.warning(err.msg)
      // this.majorList = res.data
      res.data.forEach(item => {
        let obj = {
          value: item,
        }
        this.majorList.push(obj)
      })
    },
    async handleMaterialsQueryFn(id) {
      const [res, err] = await to(materialsInfoQuery({ id: id }))
      if (err) return this.$message.warning(err.msg)
      this.form = res.data
      if (res.data.jobId && res.data.jobLevel) {
        this.form.jobList = [String(res.data.jobId), res.data.jobLevel]
        this.handleGetMajorList(res.data.jobId)
      }
      if (!res.data.workCertificateList) this.form.workCertificateList = []
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.includes('image')
      if (!isImage) {
        this.$message.error('上传文件类型必须是图片!')
      }
      const isLt5M = file.size / 1024 / 1024 < 20
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isImage && isLt5M
    },
    beforeAvatarUpload1(file) {
      const isImage = file.type.includes('image')
      if (!isImage) {
        this.$message.error('上传文件类型必须是图片!')
      }
      const isLt5M = file.size / 1024 / 1024 < 10
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      return isImage && isLt5M
    },
    beforeAvatarUpload2(file) {
      const isImage = file.type.includes('image')
      if (!isImage) {
        this.$message.error('上传文件类型必须是图片!')
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isImage && isLt5M
    },
    //证件照正面
    async handlePhotoFrontSuccess(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.form.photoFront = response.data
    },
    //证件照背面
    async handlePhotoBackSuccess(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.form.photoBack = response.data
    },
    //登记照
    async handleRegistrationPhotoSuccess(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.form.registrationPhoto = response.data
    },
    //毕业证书照片
    async handleDiplomaPhotoSuccess(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.form.diplomaPhoto = response.data
    },
    //工作证明
    handleBeforeWorkCertificateFileUpload(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.form.workCertificateList.push({
        name: fileList.name,
        url: response.data,
      })
    },
    handleWorkCertificateRemove(file, fileList) {
      this.form.workCertificateList = fileList
    },
    async handleDownLoad(file) {
      const response = await fetch(file.url)
      const blob = await response.blob()
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = file.name
      a.click()
      window.URL.revokeObjectURL(url)
    },
    //参保证明
    handleProofListFileUpload(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.form.proofList.push({
        name: fileList.name,
        url: response.data,
      })
    },
    handleProofListRemove(file, fileList) {
      this.form.proofList = fileList
    },
    //附件
    handleAttachmentListFileUpload(response, fileList) {
      this.form.attachmentList.push({
        name: fileList.name,
        url: response.data,
      })
    },
    handleAttachmentListRemove(file, fileList) {
      this.form.attachmentList = fileList
    },
  },
}
</script>
<style lang="scss" scoped>
.materialsDetail {
  padding: 20px;
  height: 100%;
  .main {
    display: flex;
  }
  .btnGroup {
    margin-left: 100px;
    width: 200px;
    .checkBtn {
      width: 100%;
      height: 40px;
      margin-left: 0;
      margin-bottom: 20px;
    }
  }
  /deep/.baseForm {
    padding-bottom: 50px !important;
    .el-input,
    .el-textarea,
    .el-date-editor {
      width: 440px !important;
      .el-input__inner,
      .el-textarea__inner {
        border-radius: 2px;
      }
      input {
        height: 40px;
      }
    }
    .imageUpload {
      display: flex;
      .imageFront {
        margin-right: 30px;
      }
      .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        position: relative;
        width: 148px;
        height: 98px;
        img {
          @extend %width-height;
        }
        .avatar-uploader-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -15px;
          margin-left: -15px;
          font-size: 28px;
          color: #8c939d;
        }
        &:hover {
          border-color: #3671bf;
        }
      }
      .el-upload__tip {
        margin-top: 0;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
      }
    }
    .registrationPhoto {
      .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        position: relative;
        width: 148px;
        height: 148px;
        img {
          @extend %width-height;
        }
        .avatar-uploader-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -15px;
          margin-left: -15px;
          font-size: 28px;
          color: #8c939d;
        }
        &:hover {
          border-color: #3671bf;
        }
      }
      .el-upload__tip {
        margin-top: 0;
        font-size: 14px;
        line-height: 16px;
      }
    }
    .workUpload {
      .el-upload-list__item {
        width: 500px !important;
      }
      .downLoadCard {
        margin-top: 10px;
        span {
          display: block;
        }
        .download-text {
          line-height: 14px;
          cursor: pointer;
          margin-bottom: 10px;
          color: #1890ff;
        }
      }
    }
    .checkBtn {
      margin-top: 50px;
      width: 350px;
      height: 40px;
    }
  }
}
</style>
